// extracted by mini-css-extract-plugin
module.exports = {"td":"TableCell_td__mCGuq","primary":"TableCell_primary__35V35","secondary":"TableCell_secondary__wxw-G"};